import { Snackbar, SNACKBAR_TYPES } from "@lysaab/ui-2";
import { FormattedMessage } from "react-intl";

export const ConfirmationErrorSnackbar = () => (
  <Snackbar type={SNACKBAR_TYPES.ERROR} icon>
    <FormattedMessage id="confirmation.error.text" />
  </Snackbar>
);
